module.exports = __webpack_public_path__ + "img/img_side_elegant.4ae22e37.png";